import ToggleSlide from './slide'

$(() => {
  new ToggleSlide(
    $('.js-toggle-career-guide'),
    $('.js-career-guide')
  )
})
